// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dLYZ","label":"styles_label__8WEOr"};